export const
    apiUserUrl = process.env.API_URL + '/user',
    apiLoginUrl = process.env.API_URL + '/login/vkontakte',
    apiAffiliateReferrerUrl = process.env.API_URL + '/affiliate/referrer',
    apiSessionPropertiesUrl = process.env.API_URL + '/session',
    appUrl = process.env.APP_URL,
    landingUrl = 'https://adspoiler.com';
